import { RecurrenceInterval } from "@mimber/schema"

export {
  DAY_OF_WEEK_OPTIONS,
  WEEK_INDEX_OPTIONS,
  MONTH_OPTIONS,
} from "../ScheduleActionForm/ScheduleActionForm.utils"

// Re-export INTERVAL_OPTIONS excluding QUARTERLY for event recurrence
import { INTERVAL_OPTIONS as ALL_INTERVAL_OPTIONS } from "../ScheduleActionForm/ScheduleActionForm.utils"
export const INTERVAL_OPTIONS = ALL_INTERVAL_OPTIONS.filter(
  (opt) => opt.value !== RecurrenceInterval.QUARTERLY
)
